import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { Component, Input, OnInit } from '@angular/core';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { DevicesCardV3Component } from '../devices-card-v3/devices-card-v3.component';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import * as Highcharts from 'highcharts';
import * as _ from 'underscore';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { CONSTANTS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-r3-conversions',
	templateUrl: './r3-conversions.component.html',
	styleUrls: ['./r3-conversions.component.css']
})
export class R3ConversionsComponent extends DevicesCardV3Component implements OnInit {
	@Input() externalwidgetsconfiguration: any;
	@Input() metricsarray: any;

	public widgetsConfiguration;
	public donutPartData;
	public initialAxisDataSrc = {
		allowZeroData: true,
		colorPalette: {
			color: '',
			isCustom: false
		},
		dataLabels: {
			enabled: true
		},
		dataType: 'number',
		displayName: '',
		format: '',
		readFrom: 'conversions',
		rowIdentity: {
			key: 'conversion_action',
			value: ''
		},
		showInSeries: 'true'
	};
	public daypartColors = ['primary', 'secondary', 'tertiary', 'quaternary', 'quinary'];
	public totalsArray = [];
	public metricsArray = [];
	public metricObject;
	responseData: any;
	groupByData: any;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.widgetsConfiguration = this.externalwidgetsconfiguration
			? JSON.parse(decodeURI(this.externalwidgetsconfiguration))
			: null;
		this.metricsArray = JSON.parse(decodeURI(this.metricsarray));
		if (this.metricsArray) {
			this.metricsArray = _.filter(this.metricsArray, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		super.ngOnInit();
	}

	processResponseData(responseData: any): void {
		for (const metric of this.metricsArray) {
			if (metric) {
				const sum_conversions = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				const all_conv_sum = responseData.reduce((s, f) => s + Number(f['all_conversions']), 0);
				this.totalsArray['conversions'] = sum_conversions;
				this.totalsArray['all_conversions'] = all_conv_sum;
				this.totalsArray['conversion_rate'] = ((sum_conversions / parseInt(responseData[0].clicks)) * 100).toFixed(2);
			}
		}

		this.metricObject = [
			{
				name: 'CONVERSIONS',
				value: this.totalsArray['conversions'].toLocaleString(),
				tooltip:
					'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
			},
			{
				name: 'CONVERSION RATE',
				value: this.totalsArray['conversion_rate'] + '%',
				tooltip: 'The average number of conversions per ad interaction, as a percentage.'
			},
			{
				name: 'ALL CONVERSIONS',
				value: this.totalsArray['all_conversions'].toLocaleString(),
				tooltip:
					'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
			}
		];

		this.donutPartData = this.conversionsDataProcess(responseData);
		this.generateAxisLabelsSoruce();
		this.widgetsConfiguration.chartConfig.toolTip.formatter = this.getToolTipFormatter();
		const deviceData = this.mapDeviceReponseDataToModel(responseData);
		this.deviceChartObjArray = this.buildDeviceChartCollatorByFields(deviceData);
		this.setSubTitle(0);
		this.requestDeviceDatatableData();
	}

	conversionsDataProcess(responseData: any) {
		if (responseData?.length <= 5) {
			responseData = responseData;
		} else {
			let tempAllConversions = 0;
			let tempCoversions = 0;
			let tempclicks = 0;

			for (let i = 4; i < responseData?.length; i++) {
				tempAllConversions += Number(responseData[i]['all_conversions']);
				tempCoversions += Number(responseData[i]['conversions']);
				tempclicks = Number(responseData[i]['clicks']);
			}
			let tempDataArray = {
				all_conversions: tempAllConversions.toString(),
				conversion_action: 'Additional',
				conversions: tempCoversions.toString(),
				clicks: tempclicks.toString(),
				tooltip: 'All other conversion actions.'
			};
			let updatedRespData = responseData.splice(0, 4);
			updatedRespData.splice(4, 0, tempDataArray);
			responseData = updatedRespData;
			this.responseData = responseData;
		}
		this.groupByData = responseData.filter((obj) => {
			return obj['conversions'] != 0 || obj['all_conversions'] != 0;
		});
		return this.groupByData;
	}

	generateAxisLabelsSoruce(): void {
		this.widgetsConfiguration.chartConfig.series[0].axisDataSource = [];
		this.donutPartData.forEach((daypart, index) => {
			const axisDataSrc = JSON.parse(JSON.stringify(this.initialAxisDataSrc));
			axisDataSrc.displayName = `${daypart.conversion_action.toLowerCase()}`;
			axisDataSrc.rowIdentity.value = daypart.conversion_action;
			axisDataSrc.colorPalette.color = this.daypartColors[index];
			if (daypart.conversions === '0') {
				axisDataSrc.showInSeries = false;
				axisDataSrc.dataLabels.enabled = false;
			}
			this.widgetsConfiguration.chartConfig.series[0].axisDataSource.push(axisDataSrc);
		});
	}

	getToolTipFormatter(): any {
		return function (): string {
			return `<div style='padding: 3px; color: #FFFFFF; font-size: 14px;'>
      <div style='display: flex; align-items: center;'>
					<div style='font-family: "Roboto"; font-weight: 400;'>${this.percentage.toFixed(2)}%</div>
					<div style='font-family: "Roboto"; font-weight: 400;'>&nbsp;(${Highcharts.numberFormat(this.y, 0, '', ',')})</div>
				</div>
				<div style='display: flex; align-items: center;'>
					<div style='color: ${
						this.color
					}; font-size: 27px; margin-right: 4px;'>●</div><div style='font-family: "Open Sans"; font-weight: 600; text-transform: capitalize;
          '>${this.key}</div>
				</div>	
			</div>`;
		};
	}

	requestDeviceDatatableData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;

			if (response.success && response.data.length > 0) {
				this.dataTableObj.columns = this.generateColumnConfigurationForConversionsTable();
				this.generateDateTableConfiguration(this.conversionsDataProcess(response.data));
			} else {
				this.hasData = false;
				this.seriesData = [];
			}
		});
	}

	generateColumnConfigurationForConversionsTable(): any[] {
		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		const columnsConfig = UtilityService.checkForVisibilityPermissions(this.devicedatatableconfig.columns, dateSet);
		const sortedColumnConfig = _.sortBy(columnsConfig, 'columnOrder');
		const columns = [];
		for (const colConfig of sortedColumnConfig) {
			const colObj: any = {} as any;
			colObj.name = colConfig.columnName;
			colObj.prop = colConfig.columnType === 'number' ? 'formatted_' + colConfig.columnKey : colConfig.columnKey;
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.hasProgressBar = colConfig.columnHasProgressBar;
			colObj.columnKey = colConfig.columnKey;
			if (colConfig.columnType === 'number') {
				colObj.comparator = this.comparator.bind(this, colConfig.columnKey);
			}
			colObj.resizeable = false;
			colObj.columnHasTooltip = colConfig.columnHasTooltip;
			colObj.columnTooltip = colConfig.columnTooltip;
			columns.push(colObj);
		}
		return columns;
	}

	downloadCSVData(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.devicedatatableconfig.csvQueryKey,
			this.devicedatatableconfig.downloadFileName,
			this.downloadCSVColumns
		);
	}
}
